import React from 'react';

import { connect } from 'react-redux';
import { IApplicationState } from 'ducks/reducers';
import { selectors as configSelectors } from 'ducks/appConfig';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';
import CustomerPricingLookupField, { ICustomerPricingLookupFieldProps } from './CustomerPricingLookupField';

const mapStateToProps = (state: IApplicationState) => ({
    isV2: configSelectors.isV2(state),
    isV3: configSelectors.isV3(state),
});

const ConnectedComponent = connect(mapStateToProps, null)((props: Readonly<Omit<
    ICustomerPricingLookupFieldProps,
    'classes' | 'onSearch' | 'onFindOption'>>) => {
    return (<CustomerPricingLookupField {...props} />);
});

export default React.forwardRef(
    (props: Readonly<Omit<ICustomerPricingLookupFieldProps, 'classes' | 'onSearch' | 'onFindOption'>>, ref: React.Ref<IBasicLookupFieldHandle>) => {
        return <ConnectedComponent {...props} fieldRef={ref} />;
    });
